angular.module('impactx.catalog').controller('ExtendCatalogLastDateCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    '$window',
    'dataGen',
    'trns',
    'newLastDateProduct',
    '$mdToast',
    ExtendCatalogLastDateCtrl]);

function ExtendCatalogLastDateCtrl($scope, $mdDialog, themeFactory, $window, dataGen, trns, newLastDateProduct, $mdToast)
{
    $scope.minDate = new Date();
    $scope.trns = trns;
    $scope.theme = themeFactory.getTheme();
    $scope.newLastDateProduct = newLastDateProduct;
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function (newLastDateProduct)
    {
        $mdDialog.hide(newLastDateProduct);
    };
}